import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export function removeAttributeIrisFromMappings(
  model: Model,
  value: string,
  domain?: string
) {
  let mappings: Mapping[];

  if (domain) {
    // Get all mappings associated with the (domain) class
    mappings = model.linkDataArray.filter(
      (link) => isMapping(link) && link.to === getModelConceptClassKey(domain)
    ) as Mapping[];
  } else {
    // Get all mappings
    mappings = model.linkDataArray.filter((link) =>
      isMapping(link)
    ) as Mapping[];
  }

  if (!mappings) {
    return;
  }

  // Remove all references to the attribute iri (value) from those mappings
  mappings.forEach((mapping) => {
    Object.entries(mapping.fields).forEach(([fieldId, mappingField]) => {
      const matchIndex = mappingField.targets.indexOf(value);
      if (matchIndex !== -1) {
        setDataProperty<Mapping>(model)(mapping, 'fields', {
          ...mapping.fields,
          [fieldId]: {
            ...mappingField,
            targets: [
              ...mappingField.targets.slice(0, matchIndex),
              ...mappingField.targets.slice(matchIndex + 1),
            ],
          },
        });
        doMappingUpdated(mapping)(model);
      }
    });
  });
}
